'use client'

import { CardText } from '@morpho-org/ui-v6/server'

const InfoMyPositionDataListError = () => {
  return (
    <CardText
      height="100px"
      text="An error occurred."
      withBorder
      data-testid="market-your-position-info-error"
    />
  )
}

export default InfoMyPositionDataListError
